// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__q2n+q","count":"styles_count__iCOMc","input":"styles_input__0aKuG"};